module.exports = __webpack_public_path__ + "img/member-verify-icon-1.73c4b944.png";